__webpack_require__.p = "https://stdatavisualpublic001.blob.core.windows.net/uk-war-timeline/prod/ua/";